import $ from 'jquery'

export default () => {

    function initMap() {
        let mapEL = document.getElementById("map");

        if (typeof mapEL.dataset.center === 'undefined') {
            return;
        }

        let center = JSON.parse(mapEL.dataset.center)

        window.map = new google.maps.Map(mapEL, {
            center: { lat: parseFloat(center.lat), lng: parseFloat(center.lng) },
            zoom: 13,
            mapTypeControl: false,
            gestureHandling: 'cooperative',
            zoomControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            scaleControl: false,
            styles: [
                {
                    featureType: "poi",
                    elementType: "labels",
                    stylers: [
                        { visibility: "off" }
                    ]
                }
            ]
        });

        if (typeof mapEL.dataset.markers === 'undefined') {
            return;
        }

        let markers = JSON.parse(mapEL.dataset.markers)

        markers.forEach(marker => {
            new google.maps.Marker({
                position: { lat: parseFloat(marker.lat), lng: parseFloat(marker.lng) },
                map: window.map,
            });
        });
    }

    window.initMap = initMap;
    window.map = null;

}
